import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { UserIcon } from "../../../../components/parts/user-icon"
import { Notification } from "../../../../rpcs/dist/UserRPC"
import Color from "../../../../style/enum/color"
import dayjs from "dayjs"

interface IProps {
  notification: Notification
}

export const NotificationItem = ({ notification }: IProps) => {
  const n = notification
  if (n.link) {
    return (
      <LinkedItem to={n.link} key={n.id}>
        {n.icon && <UserIcon size={40} title={"お知らせ"} url={n.icon} />}
        <Info>
          <div>{n.text}</div>
          <Date>{dayjs(n.createdAt).format("YYYY/MM/DD HH:mm")}</Date>
        </Info>
      </LinkedItem>
    )
  } else {
    return (
      <Item key={n.id} as={"div"}>
        {n.icon && <UserIcon size={40} title={"お知らせ"} url={n.icon} />}
        <Info>
          <div>{n.text}</div>
          <Date>{dayjs(n.createdAt).format("YYYY/MM/DD HH:mm")}</Date>
        </Info>
      </Item>
    )
  }
}

const Item = styled.div`
  display: flex;
  padding: 15px 10px;
  border-top: 1px solid ${Color.LIGHT_GRAY};
  color: ${Color.BLACK};
  & + & {
    margin-top: -1px;
  }
`

const LinkedItem = Item.withComponent(Link)

const Info = styled.div`
  padding-left: 10px;
  font-size: 0.9rem;
`

const Date = styled.div`
  color: ${Color.DIMGRAY};
`
